<script setup lang="ts">
/*
 * @descriptions: 公告弹窗
 */
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import common from '@/utils/common'
import { homeNoticeRead } from '@/api/common'

const { VITE_APP_MJ_CLOUD_EDU_ORIGIN } = import.meta.env

// 数据初始化
const dialogVisible = ref(false)
let listData = ref([])
let activeIndex = ref(0)

const onKnow = () => {
  if (listData.value) {
    // 创建一个包含所有请求的 Promise 数组
    const promises = listData.value.map((item: any) =>
      homeNoticeRead({ article_id: item.notice_id })
    )

    // 使用 Promise.all 等待所有请求完成
    Promise.all(promises)
      .then((results) => {
        // 检查所有请求是否都返回 code === 0
        const allSuccess = results.every((res) => res.code === 0)
        if (allSuccess) {
          $emit('ok', listData.value)
        }
      })
      .catch((error) => {
        console.error('请求出错:', error)
      })
  }
}

const editDialog = (e: any) => {
  let { noticeArr } = e
  listData.value = noticeArr
  console.log('消息列表', listData.value)
}

const handleChange = (val: any) => {
  activeIndex.value = val
}

// 父子事件触发
const $emit = defineEmits(['ok'])

// 暴露组件的属性和方法
defineExpose({
  dialogVisible,
  editDialog
})
</script>

<template>
  <el-dialog
    draggable
    :show-close="false"
    :close-on-click-modal="false"
    v-model="dialogVisible"
    width="550"
    align-center
    :class="[listData.length <= 1 && 'no-arrow']"
  >
    <template #header>
      <h4>{{ listData[activeIndex].notice_title }}</h4>
    </template>
    <el-carousel
      trigger="click"
      autoplay="false"
      arrow="always"
      @change="handleChange"
    >
      <el-carousel-item v-for="(item, index) in listData" :key="index">
        <div
          class="notice-dialog-text-cont"
          v-if="item && item.notice_content"
          v-html="item.notice_content"
        ></div>
      </el-carousel-item>
    </el-carousel>
    <template #footer>
      <div class="dialog-footer text-center">
        <el-button @click="onKnow">
          <span class="blue mj-theme-ft">我知道了</span>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<style lang="scss">
.notice-dialog-text-cont {
  max-height: 300px;
  overflow: auto;
}
.no-arrow {
  .ep-carousel__arrow {
    display: none;
  }
}
</style>
